import React from "react";
import Card from "../Card";
import { Body, Helper } from "../Text";

const GridItem = ({
  customGrid,
  item,
  gridSpacing,
  onCardClick,
  isLoading,
  gridSize,
  i,
}) => {
  if (customGrid) return item;
  const {
    id,
    iconName,
    title,
    subtitle,
    image,
    elements = [],
    ...rest
  } = item || {};
  return (
    <Card
      justifyContent="center !important"
      alignItems="center"
      key={`${id}|card${i}`}
      isLoading={isLoading}
      m="1rem"
      p={gridSize === "tiny" ? "0 !important" : "a"}
      interactive
      iconName={iconName}
      onClick={() => onCardClick(item)}
      width={gridSpacing()}
      {...rest}
    >
      {image && <img src={image} alt={title || id} />}
      {title && (
        <Body center bold mt="1rem">
          {title}
        </Body>
      )}
      {subtitle && (
        <Helper center my="1rem">
          {subtitle}
        </Helper>
      )}
      {elements}
    </Card>
  );
};

export default GridItem;
